export const rootPaths = {
  root: "/",
  dashboardRoot: "dashboard",
  authRoot: "authentication",
  eligibilityRoot: "eligibility",
  layoutRoot: "layouts",
  preauthorizationRoot: "preauthorization",
  claimsRoot: "claims",
  communicationRoot: "communication",
  billingRoot: "billing",
  practitionerRoot: "practitioner",
  patientRoot: "patient",
  employeeRoot: "employee",
  insuranceCompanyRoot: "insurance-company",
  userPermissionsRoot: "user-permissions",
  reportsRoot: "reports",
  generalSettingsRoot: "general-settings",
  priceRoot: "price",
  payment: "payment",
  profileRoot: "profile",
};

export default {
  changelog: "/changelog",
  widgets: "/widgets",
  landing: "/landing",
  starter: `/${rootPaths.pagesRoot}/starter`,
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,
  verticalNavLayout: `/${rootPaths.layoutRoot}/vertical-nav-layout`,
  topNavLayout: `/${rootPaths.layoutRoot}/top-nav-layout`,
  doubleTopNavLayout: `/${rootPaths.layoutRoot}/double-top-nav-layout`,
  comboNavLayout: `/${rootPaths.layoutRoot}/combo-nav-layout`,
  login: `/${rootPaths.authRoot}/login`,
  logout: `/${rootPaths.authRoot}/logout`,
  forgotPassword: `/${rootPaths.authRoot}/forgot-password`,
  resetPassword: `/${rootPaths.authRoot}/reset-password`,
  confirmMail: `/${rootPaths.authRoot}/confirm-mail`,
  lockScreen: `/${rootPaths.authRoot}/lock-screen`,
  eligibilityCheck: `/${rootPaths.eligibilityRoot}/eligibility-check`,
  eligibilityCheckList: `/${rootPaths.eligibilityRoot}/eligibility-check-list`,
  preauthorization: `/${rootPaths.preauthorizationRoot}/preauthorization`,
  preauthorizationList: `/${rootPaths.preauthorizationRoot}/preauthorization-list`,
  viewPreauthorization: (id) =>
    `/${rootPaths.preauthorizationRoot}/preauthorization-list/view?id=${id}`,
  claimsList: `/${rootPaths.claimsRoot}/claims-list`,
  cliamPolls: `/${rootPaths.claimsRoot}/cliam-polls`,
  cliamPollsImports: `/${rootPaths.claimsRoot}/cliam-polls-imports`,
  preapareClaim: `/${rootPaths.claimsRoot}/prepare-claim`,
  communicationSolicited: `/${rootPaths.communicationRoot}/solicited`,
  communicationUnsolicited: `/${rootPaths.communicationRoot}/unsolicited`,
  billingInvoicesList: `/${rootPaths.billingRoot}/invoices-list`,
  practitionerList: `/${rootPaths.practitionerRoot}/practitioner-list`,
  addPractitionerList: `/${rootPaths.practitionerRoot}/add-practitioner-list`,
  practitionerImports: `/${rootPaths.practitionerRoot}/practitioner-imports`,
  patientList: `/${rootPaths.patientRoot}/patient-list`,
  viewPatient: (id) => `/${rootPaths.patientRoot}/patient-list/view/${id}`,
  patientImports: `/${rootPaths.patientRoot}/patient-imports`,
  priceList: `/${rootPaths.priceRoot}/price-list`,
  priceImport: `/${rootPaths.priceRoot}/price-import`,
  addPriceList: `/${rootPaths.priceRoot}/add-price-list`,
  employeeList: `/${rootPaths.employeeRoot}/employee-list`,
  addEmpolyeeList: `/${rootPaths.employeeRoot}/add-employee`,
  employeeImport: `/${rootPaths.employeeRoot}/employee-import`,
  insuranceCompanyRoot: `/${rootPaths.insuranceCompanyRoot}`,
  branchSettings: `/${rootPaths.generalSettingsRoot}/branch-settings`,
  fieldSettings: `/${rootPaths.generalSettingsRoot}/field-settings`,
  icdsCodeSettings: `/${rootPaths.generalSettingsRoot}/icds-code-settings`,
  branchList: `/${rootPaths.generalSettingsRoot}/branch-list`,
  addBranch: `/${rootPaths.generalSettingsRoot}/add-branch`,
  branchImport: `/${rootPaths.generalSettingsRoot}/import-branch`,
  userPermissionList: `/${rootPaths.userPermissionsRoot}/permission-list`,
  createClaim: `/${rootPaths.claimsRoot}/create-claim`,
  editPermission: `/${rootPaths.userPermissionsRoot}/edit-permission`,
  viewClaimRequest: `/${rootPaths.claimsRoot}/view-claim-request`,
  viewClaimResponse: `/${rootPaths.claimsRoot}/view-claim-response`,
  claimDashboard: `/${rootPaths.claimsRoot}/claim-dashboard`,
  payment: `/${rootPaths.claimsRoot}/payment`,
  systemPrivillage: `/${rootPaths.generalSettingsRoot}/system-privillage`,
  profile: `/${rootPaths.profileRoot}`,
};
